import React, { useState } from 'react';
import { MyCampaignsImg } from '../../../static/constant/imgConstants';
import { useDispatch } from 'react-redux';
import { uploadCampaignFile } from "../../../store/campaignStore/actions/CreateCampaignActions/uploadCampaignFileActions";
import { uploadReferenceVideo } from "../../../store/campaignStore/actions/CreateCampaignActions/uploadReferenceVideoActions";
import CampaignDate from '../BrandCampaignCreation/CampaignDate';
import { useToast } from '../../../hooks/useToast';

const VideoCampaign = ({
    setStartDate,
    setEndDate,
    startDate,
    endDate,
    setErrors,
    errors,
    setVideoPosition,
    videoPosition,
    mediaFileLink,
    mediaFileName,
    setMediaFileLink,
    setMediaFileName,
    loading: loading,
    setLoading: setLoading,
    brandId,
    userType,
    referenceVideoUpload,
    setReferenceVideoUpload,
    setReferenceVideoFile,
    descriptionLink,
    setDescriptionLink,
}) => {
    const dispatch = useDispatch();
    const Toast = useToast();

    const [isDragging, setIsDragging] = useState(false);
    const [videoFileName, setVideoFileName] = useState(mediaFileName);
    const [refVideoFileName, setRefVideoFileName] = useState('');
    // const [loading, setLoading] = useState(false); // Loading state


    const handleFileUpload = (file) => {

        if (!file || !file.type.startsWith("video/")) {
            setErrors((prevState) => ({
                ...prevState,
                mediaFileLink: "Please upload a valid video file",
            }));
            return;
        }

        setLoading(true); // Start loading
        const localUrl = URL.createObjectURL(file); // Create local URL for preview
        setVideoFileName(file.name); // Set the video file name for display

        const videoElement = document.createElement("video");
        videoElement.src = localUrl;
        videoElement.preload = "metadata";


        videoElement.onloadedmetadata = () => {
            URL.revokeObjectURL(videoElement.src);
            const duration = Math.round(videoElement.duration);

            if (duration > 20) {
                setErrors((prevState) => ({
                    ...prevState,
                    mediaFileLink: "Video duration must not exceed 20 seconds",
                }));
                setLoading(false);
                setVideoFileName(null);
                return; // Stop execution if video duration is invalid
            }

            const payload = {
                file: file,
                duration: duration,
                isBgc: false,
                brandId,
                userType
            };

            dispatch(uploadCampaignFile(payload, (response, status) => {
                if (status === 200) {

                    setMediaFileName(file.name);
                    setMediaFileLink(response); // Update media link with returned URL
                    setLoading(false); // Stop loading
                    setErrors((prevState) => {
                        const { ["mediaFileLink"]: _, ...updatedObject } = prevState;
                        return updatedObject;
                    });
                } else {
                    Toast(response, 'error');
                }
            }));
        }
    };

    const handleDragOver = (e) => {
        e.preventDefault();
        setIsDragging(true);
    };

    const handleDragLeave = () => {
        setIsDragging(false);
    };

    const handleDrop = (e) => {
        e.preventDefault();
        setIsDragging(false);
        const file = e.dataTransfer.files[0];
        if (file && file.type.startsWith('video/')) {
            handleFileUpload(file);
        } else {
            setErrors(prevState => ({ ...prevState, mediaFileLink: 'Please upload a valid video file' }));
        }
    };

    const handleRemoveVideo = () => {
        setVideoFileName(null); // Clear the video file name
        setMediaFileLink(null); // Clear the media file link
        setMediaFileName(null);
        setLoading(false); // Reset loading state
    };

    return (
        <div className="flex flex-row justify-between items-start w-full flex-wrap">
            <div className='w-[49%] flex flex-col mb-[2rem] h-[24rem]'>
                <label className="text-[1.6rem] text-[#111729] inter-font font-[400]">Videos to be used<span
                    className="text-[1.6rem] text-[#E3351D]">*</span></label>
                <div
                    className={`w-full h-[90%] flex justify-center items-center border border-gray-300 mt-[1.4rem] rounded-lg text-center bg-gray-50 ${isDragging ? 'bg-green-100 border-green-500' : ''
                        }`}
                    onDragOver={handleDragOver}
                    onDragLeave={handleDragLeave}
                    onDrop={handleDrop}
                >
                    {!videoFileName && !mediaFileName && !loading ? (
                        <>
                            <input
                                type="file"
                                accept="video/*"
                                className="w-full hidden"
                                onChange={(e) => {
                                    handleFileUpload(e.target.files[0])
                                }}
                                id="fileUpload"
                            />
                            <label htmlFor="fileUpload" className="cursor-pointer">
                                <p className='text-[1.4rem] inter-font font-[400] text-[#111729]'>
                                    Drag files here <br />
                                    or <span className='text-[1.4rem] inter-font font-[400] text-[#34A853]'>browse your computer</span>
                                </p>
                            </label>
                        </>
                    ) : loading ? (
                        <p className="text-[1.6rem] text-[#111729] inter-font font-[400]">Uploading...</p>
                    ) : (
                        <div className="flex flex-col items-center">
                            <p className="text-[1.4rem] inter-font font-[400] text-[#111729] mb-2">
                                Selected video: {videoFileName}
                            </p>
                            <div className="flex space-x-4">
                                <button
                                    className="text-red-500 text-[1.6rem] font-[400] underline"
                                    onClick={handleRemoveVideo}
                                >
                                    Remove
                                </button>
                            </div>
                        </div>
                    )}
                </div>
                {errors?.mediaFileLink && (
                    <p className="text-red-500 text-[1.3rem] inter-font font-[400]">
                        {errors?.mediaFileLink}
                    </p>
                )}
            </div>
            <div className="w-[49%]">
                <label className="text-[1.6rem] text-[#111729] inter-font font-[400]">
                    Video Position<span className="text-[1.6rem] text-[#E3351D]">*</span>
                </label>
                <select
                    className="w-full text-[1.6rem] text-[#111729] inter-font font-[400] border border-gray-300 rounded-lg p-4 mt-[1rem]"
                    value={videoPosition}
                    onChange={(e) => {
                        setVideoPosition(e.target.value);
                        setErrors((prevState) => {
                            const { ["videoPosition"]: _, ...updatedObject } = prevState;
                            return updatedObject;
                        });
                    }}
                >
                    <option value="">Select Position</option>
                    <option value="START">START</option>
                    <option value="MIDDLE">MIDDLE</option>
                    <option value="END">END</option>

                </select>
                {errors?.videoPosition && (
                    <p className="text-red-500 text-[1.6rem] inter-font font-[400]">
                        {errors?.videoPosition}
                    </p>
                )}
            </div>
            <CampaignDate
                startDate={startDate}
                endDate={endDate}
                errors={errors}
                setStartDate={setStartDate}
                setEndDate={setEndDate}
                setErrors={setErrors}
                type={"VIDEO"}
            />
            {/* ── Reference Guidance Video (optional) ── */}
            <div className="w-full mb-[2rem] mt-[1rem]">
                <label className="text-[1.6rem] text-[#111729] inter-font font-[400] leading-relaxed pb-2">
                    Reference Guidance Video
                    <span className="text-[1.4rem] text-gray-400 ml-2">(optional)</span>
                </label>
                <div className="flex items-center gap-4 mt-[1rem]">
                    <input type="file" accept="video/*" className="hidden" id="videoRefVideoUpload"
                        disabled={loading}
                        onChange={(e) => {
                            const selectedFile = e.target.files[0];
                            if (!selectedFile) return;
                            if (!selectedFile.type.startsWith("video/")) {
                                setErrors((prevState) => ({
                                    ...prevState,
                                    referenceVideoUpload: "Please upload a valid video file for reference guidance",
                                }));
                                return;
                            }
                            setErrors((prevState) => {
                                const { ["referenceVideoUpload"]: _, ...updatedObject } = prevState;
                                return updatedObject;
                            });
                            setLoading(true);
                            setRefVideoFileName(selectedFile.name);
                            dispatch(uploadReferenceVideo({ file: selectedFile }, (status, response, message) => {
                                if (status === 200) {
                                    setReferenceVideoUpload(response);
                                    setLoading(false);
                                } else {
                                    Toast(message || "Upload failed", "error");
                                    setLoading(false);
                                    setReferenceVideoUpload('');
                                    setRefVideoFileName('');
                                }
                            }));
                        }}
                    />
                    <label htmlFor="videoRefVideoUpload" className={`cursor-pointer border border-gray-300 rounded-lg px-6 py-3 text-[1.4rem] text-[#111729] inter-font font-[400] hover:bg-gray-50 ${loading ? 'opacity-50 pointer-events-none' : ''}`}>
                        {loading ? "Uploading..." : "Choose Video"}
                    </label>
                    {refVideoFileName ? (
                        <span className="text-[1.4rem] text-gray-600 inter-font font-[400] truncate max-w-[24rem]">
                            {refVideoFileName}
                        </span>
                    ) : referenceVideoUpload ? (
                        <span className="text-[1.4rem] text-blue-600 inter-font font-[400]">Video Uploaded</span>
                    ) : null}
                    {(refVideoFileName || referenceVideoUpload) && (
                        <button type="button" onClick={() => { setReferenceVideoFile(null); setReferenceVideoUpload(''); setRefVideoFileName(''); }} className="text-[1.2rem] text-red-500 hover:underline">
                            Remove
                        </button>
                    )}
                </div>
                {errors?.referenceVideoUpload && (
                    <p className="text-red-500 text-[1.4rem] inter-font font-[400] mt-1">
                        {errors?.referenceVideoUpload}
                    </p>
                )}
            </div>
            {/* ── Description Link (optional) ── */}
            {/* <div className="w-full mb-[2rem]">
                <label className="text-[1.6rem] text-[#111729] inter-font font-[400] leading-relaxed pb-2">
                    Description Link
                    <span className="text-[1.4rem] text-gray-400 ml-2">(optional)</span>
                </label>
                <input type="url" value={descriptionLink || ''} onChange={(e) => setDescriptionLink(e.target.value)}
                    placeholder="https://example.com/reference"
                    className="w-full border border-gray-300 text-[1.6rem] inter-font font-[400] mt-[1rem] rounded-lg p-4 bg-white text-gray-900 shadow-sm"
                />
            </div> */}
        </div>
    )
}

export default VideoCampaign
